var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9953 34.9609C23.2562 34.9609 17.5 36.0234 17.5 40.2734C17.5 44.525 23.2203 45.625 29.9953 45.625C36.7344 45.625 42.4906 44.5641 42.4906 40.3125C42.4906 36.0609 36.7719 34.9609 29.9953 34.9609Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.9973 30.9125C34.5879 30.9125 38.266 27.2328 38.266 22.6437C38.266 18.0547 34.5879 14.375 29.9973 14.375C25.4082 14.375 21.7285 18.0547 21.7285 22.6437C21.7285 27.2328 25.4082 30.9125 29.9973 30.9125Z",
    fill: "#CE2600"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 59.5,
    height: 59.5,
    rx: 13.75,
    stroke: "#CE2600",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOutline);
export default __webpack_public_path__ + "static/media/profile-outline.2856c6f8592871834be04bd576d350fb.svg";
export { ForwardRef as ReactComponent };